import { gate } from 'hub-http/gates';
const GATES = {
  FULL_APP_DETAILS_ENDPOINT: gate('OAuth:ApplicationAuthorizationsAppDetailsGate'),
  DEVELOPERS_UNIFIED_APPS_PRIVATE_BETA: gate('Developers:UnifiedApps:PrivateBeta')
};
export default GATES;